import gButton from "@/components/g-button/g-button.vue";
import gCard from "@/components/g-card/g-card.vue";
import gPdf from "@/components/g-pdf/g-pdf.vue";

const name = 'HistoricoPedidoExpedidoFaturado'

export default {
  name,

  components:{ 
    "g-button": gButton,
    "g-card": gCard,
    "g-pdf": gPdf,
  },

  props: { },

  mounted() { 
    this.GetHistoricoDoPedido();
   },

  updated() { },

  data() {
    return { 
      executarvisualizacao: 0,
      linhaSelecionada: {},
      pdfdownload: false,
      pdfvisualizacao: false,
      PedidoId: null,
      renderiza: false,
      numeroParcela: '',
      codigoPedido: '',
      HistoricoParcelasArray:[],
      popup : false,
      mensagemvazio: false,
      Colunas: [
        { field: "horaAlteracaoFormatada", header: "Data" },
        { field: "nome", header: "Usuário" },
        { field: "descricaoCausa", header: "Causa" },
        { field: "nomeSolicitante", header: "Solicitante" },
        { field: "descricaoCargo", header: "Cargo" },
        { field: "tipoManutencao", header: "Tipo da Manutenção" },
    ],
    ColunasSubGrid: [
      { field: "descricaoObservacao", header: "Observação" },
      { field: "descricaoAlteracao", header: "Alteração" },
    ],
    }
  },

  methods: { 
    voltar() {
      this.$router.push(`/pedido-expedido-faturado`);
    },

    imprimir()
    {  
      this.renderiza = true
      this.PedidoId = this.$route.params.id
      this.executarvisualizacao++
    },

    generatePdf() {
      this.executarvisualizacao++
    },

    gerarPdf() {
      this.generatePdf()
    },

    GetHistoricoDoPedido() {
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `Pedido/GetHistoricoDoPedido/${this.$route.params.id}/${this.$route.params.numeroParcela}`,
      })
        .then((response) => {
          this.codigoPedido = response.data.data[0].codigoPedido;
          this.numeroParcela = response.data.data[0].numeroParcela;
          this.HistoricoParcelasArray = response.data.data;

        })
        .catch(() => {
        });
    }
  },

  computed: { }
};